<template>
  <definition-list ref="definitionList" :isDataSource="'true'"></definition-list>
</template>

<script>

import DefinitionList from './definition-list.vue'

export default {
  name: 'reportDataSourceList',
  components: {
    DefinitionList
  },
  beforeRouteEnter (to, from, next) {
    if (!from.path.includes('/report-design-list') && from.path.includes('/report-design')) {
      next(vm => {
        let _this = vm
        _this.$refs.definitionList.getTableData()
      })
    } else {
      next()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/report/design/report-data-source-list.vue